export {Label, type LabelProps, type SpectrumLabelProps} from '../../../src/label/Label';
